import { useContext } from 'react';
import { MediaContext, MediaConsumerProps } from '../providers';

export const useMediaContext = (): MediaConsumerProps => useContext<MediaConsumerProps>(MediaContext);
